import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import logoWhite from "@/assets/logo-white.png";
import logoDark from "@/assets/logo-dark.png";

interface LogoProps {
  variant?: "light" | "dark";
  className?: string;
  withLink?: boolean;
}

// VRP Flooring brand mark — light version for dark surfaces, dark version for light surfaces.
export function Logo({ variant = "dark", className, withLink = true }: LogoProps) {
  const src = variant === "light" ? logoWhite : logoDark;
  const img = (
    <img
      src={src}
      alt="VRP Flooring LLC"
      className={cn("h-9 md:h-11 w-auto select-none", className)}
      draggable={false}
    />
  );
  if (!withLink) return img;
  return (
    <Link to="/" aria-label="VRP Flooring — Home" className="inline-flex items-center">
      {img}
    </Link>
  );
}
